var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgYoutubeicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 20,
    viewBox: "0 0 28 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.8233 0.689322H6.26731C3.21398 0.689322 0.740646 3.13599 0.740646 6.15466V13.8453C0.740646 16.864 3.21531 19.312 6.26731 19.312H21.8233C24.8766 19.312 27.35 16.864 27.35 13.8453V6.15466C27.35 3.13599 24.8753 0.687988 21.8233 0.687988V0.689322ZM18.086 10.3733L10.81 13.8067C10.7656 13.828 10.7165 13.8378 10.6674 13.8351C10.6182 13.8324 10.5705 13.8173 10.5287 13.7913C10.4869 13.7652 10.4524 13.729 10.4284 13.686C10.4044 13.643 10.3916 13.5946 10.3913 13.5453V6.46666C10.3922 6.41715 10.4056 6.36868 10.4303 6.32576C10.4549 6.28283 10.4901 6.24685 10.5324 6.22116C10.5747 6.19547 10.6229 6.18091 10.6723 6.17884C10.7218 6.17677 10.771 6.18726 10.8153 6.20932L18.0926 9.85599C18.1411 9.88016 18.1818 9.91751 18.21 9.96376C18.2382 10.01 18.2528 10.0633 18.2521 10.1174C18.2514 10.1716 18.2354 10.2244 18.2061 10.2699C18.1767 10.3154 18.1351 10.3517 18.086 10.3747V10.3733Z",
    fill: "#F9F9F9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutubeicon);
export default __webpack_public_path__ + "static/media/youtubeicon.188373801510d0d1fdd38eb14044eafe.svg";
export { ForwardRef as ReactComponent };